export interface IForecastGuidanceDefaultStateSettings {
    fontSize: number;
    showLastUpdated: boolean;
    showBoxAround: boolean;
}
export interface IForecastGuidanceDefaultState {
    settings: IForecastGuidanceDefaultStateSettings;
    content?: string;
    lastUpdated: string;
    title: string;
}

const DefaultState: IForecastGuidanceDefaultState = {
    settings: {
        fontSize: 100,
        showLastUpdated: true,
        showBoxAround: true,
    },
    content: 'Add forecast guidance, commentaries or outlook here',
    lastUpdated: new Date().toDateString(),
    title: 'Forecast Guidance',
};

export default DefaultState;
